if ( ! HTMLElement.prototype.once ) {
    HTMLElement.prototype.once = function () { 
        
        if (!this.dataset.once){
            this.dataset.once = true;
            return this;
        }
        // otherwise return a new unattached element to prevent failing
        return document.createElement('div');
    }
}

if ( ! String.prototype.getDecimals ) {
    String.prototype.getDecimals = function() {
        var num = this,
            match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        if ( ! match ) {
            return 0;
        }
        return Math.max( 0, ( match[1] ? match[1].length : 0 ) - ( match[2] ? +match[2] : 0 ) );
    }
}